import { Pipe, PipeTransform } from "@angular/core";
import * as dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { ADPResourceService as ResourceService } from 'digital-core';

@Pipe({
  name: "localDateTime"
})
export class LocalDateTimePipe implements PipeTransform {
  constructor(private resourceService: ResourceService) { }
  transform(value: any, args?: any): any {
    if (!value) {
      return "";
    }
    let dateValue = new Date(value);
    dateValue.setHours(dateValue.getHours() - dateValue.getTimezoneOffset() / 60);
    dateValue.setMinutes(dateValue.getMinutes() - (dateValue.getTimezoneOffset() % 60));
    let result = dayjs(dateValue).format(
      this.resourceService.getPortalSetting('Global_DateFormat_MMMDDYYYY') != null ?
      this.resourceService.getPortalSetting('Global_DateFormat_MMMDDYYYY').Value : "MM/dd/yyyy"
    )
    return result;
  }
}
